import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    error.__ErrorBoundary = true;
    window.__COMPONENT_ERROR__?.(error, errorInfo);
  }

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <main className="not-found">
        <p className="eyebrow">Application error</p>
        <h1>We could not load this page.</h1>
        <p>Return to the home page and try the route again. You can also call Prime Path Motors at 469-960-3446.</p>
        <a className="button button-gold" href="/">Return home</a>
      </main>
    );
  }
}
